var _style, _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFullBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "20 -10 144 216",
    style: {
      enableBackground: "new 0 0 144 216"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#000000;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_807",
    className: "st0",
    d: "M61.9,129.3c0,5.6,4.5,10.2,10.1,10.4c5.6-0.2,10.1-4.8,10.1-10.4H61.9z M72,136.6 c-2.7-0.1-5.1-1.7-6.2-4.1h12.5C77.1,134.9,74.7,136.5,72,136.6z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53.9,109.9V97.8c0-4.9,2-9.6,5.5-12.9c3.6-3.5,8.4-5.4,13.4-5.4v-3.1c-12-0.1-21.8,9.4-22,21.4v12.1 c0,1.6-0.6,3.2-1.7,4.4l-7.4,8.1c-1,1.1-0.9,2.7,0.2,3.7c0.5,0.5,1.2,0.7,1.8,0.7h29.1v-3.1h-28l6.6-7.3 C53.1,114.7,53.9,112.3,53.9,109.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M92.6,116.4l6.6,7.3h-28v3.1h29.1c0.7,0,1.3-0.2,1.8-0.7c1.1-1,1.2-2.6,0.2-3.7l-7.4-8.1 c-1.1-1.2-1.7-2.8-1.7-4.4V97.8c-0.2-12-10-21.6-22-21.4v3.1c5,0,9.8,1.9,13.4,5.4c3.5,3.4,5.5,8.1,5.5,12.9v12.1 C90.1,112.3,90.9,114.7,92.6,116.4z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullBell);
export default __webpack_public_path__ + "static/media/full_bell.7e73e92cab8cf52de28ed071831d7aa7.svg";
export { ForwardRef as ReactComponent };